import { API_ENDPOINTS } from "../constants";
import { apisClient } from "./api";

export const fetchPageData = pageName =>
  apisClient.get({
    path: `${API_ENDPOINTS.CMS}/${pageName}`,
  });
